var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-4 py-4"},[_c('h3',[_vm._v("How are the dose response curves fitted? What are the parameters for fitting?")]),_c('DrcDetails')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }